import { useQuery } from '@tanstack/react-query'
import { useAuth, useOrganization } from '@clerk/clerk-react'

import { evalKeys } from '@/lib/queryKeys'
import { fetchEvalCaseAssertions } from '../api'

export function useEvalCaseAssertionsQuery(caseId?: string) {
  const { getToken } = useAuth()
  const { organization } = useOrganization()

  return useQuery({
    queryKey: evalKeys.caseAssertions(organization?.id, caseId),
    queryFn: async () => {
      if (!caseId) throw new Error('caseId is required')
      const token = await getToken()
      if (!token) throw new Error('No authentication token available')
      return fetchEvalCaseAssertions(token, caseId)
    },
    enabled: Boolean(caseId),
    staleTime: 30_000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
